import { render, staticRenderFns } from "./CookiesInformationBox.vue?vue&type=template&id=4f3e6f5b&scoped=true&"
import script from "./CookiesInformationBox.vue?vue&type=script&lang=ts&"
export * from "./CookiesInformationBox.vue?vue&type=script&lang=ts&"
import style0 from "./CookiesInformationBox.vue?vue&type=style&index=0&id=4f3e6f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e6f5b",
  null
  
)

export default component.exports